<div class="layout-column custom-panel full-width full-height">

  <div class="layout-row layout-align-start-center header-container">
    <span class="flex br-body-2 font-weight-600">{{agent.user | userName}}</span>
    <bringoz-button type="tertiary"
                    (onClick)="onCancel()">
      <bringoz-icon iconName="close" classSize="xxl"></bringoz-icon>
    </bringoz-button>
  </div>

  <hr class="main-divider">

  <div class="flex layout-column">

    <span class="br-body-2 padding-10">{{schedule.schedule | timeWindow }}</span>

    <hr class="main-divider">

    <div *ngIf="schedule.leaveReason"
         class="flex layout-column padding-10">
      <span class="br-body-1 margin-bottom-5">{{'Reason' | translate}}:</span>
      <span class="br-body-2 margin-bottom-10">{{'SCHEDULE_REASON.' + schedule.leaveReason.type | translate}}</span>

      <span class="br-body-1 margin-bottom-5">{{'Note' | translate}}:</span>
      <span class="flex br-body-2">{{schedule.leaveReason.comment || '---'}}</span>
    </div>

  </div>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-center gap-5 footer-container">
    <bringoz-button type="tertiary"
                    (onClick)="onCancel()">
      <span>{{'Cancel' | translate}}</span>
    </bringoz-button>

    <span class="flex"></span>
    <bringoz-button theme="warning"
                    (onClick)="onReject()">
      <span translate>Reject</span>
    </bringoz-button>
    <bringoz-button theme="secondary"
                    (onClick)="onApprove()">
      <span translate>Approve</span>
    </bringoz-button>
  </div>

</div>
